module.exports = __webpack_public_path__ + "static/img/wap_foot_bg.82defa3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wap_foot_bg.png
// module id = huyZ
// module chunks = 17